var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepublicWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:70;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "layer1_2_",
    transform: "translate(-74.28567,-298.07647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3191_2_",
    transform: "translate(-160,277.14286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2176_2_",
    className: "st0",
    d: "M1349.21,141.93v103.62c129.43,19.28,248.55,70.34,349.17,145.38l72.64-73.07 C1650.93,225.03,1506.59,162.63,1349.21,141.93z M1119.59,143.31c-157.28,20.81-301.48,83.34-421.49,176.15l72.21,73.07h0.33 C871.21,317.44,990.2,266,1119.59,246.61V143.31z M1167.48,353.33v349.95c0,0-79.43,24.96-113.88,47.99L808.65,505.01 L717,597.19l245.17,246.58c-22.84,34.61-39.48,73.95-47.93,114.71h-347.2v133.53h347.93c8.49,42.03,25.22,81.02,48.16,115.56 L716.8,1453.86l92.09,92.04L1055,1299.93c34.61,23,74.02,39.63,116.17,48.13v347.88h130.16v-351.99 c41.84-8.5,80.63-25.38,114.98-48.38l244.26,245.88l91.32-91.88l-244.26-245.88c22.73-34.47,39.44-73.41,47.86-115.36h345.05 V958.49h-347.13c0,0-25.18-80.28-47.99-114.95l244.87-247.09l-91.54-92.37l-244.87,247.09 c-34.44-23.12-73.32-39.87-113.79-48.41V353.33H1167.48z M1935.12,484.22l-72.54,73.07 c74.68,101.41,125.6,221.68,144.85,352.19h102.86C2089.65,750.85,2027.46,605.22,1935.12,484.22z M533.14,484.77 c-92.16,120.88-154.22,266.27-174.85,424.72h102.97c19.22-130.31,70.01-250.24,144.53-351.54L533.14,484.77z M358.29,1139.79 c20.57,158.43,82.54,303.81,174.64,424.72l72.54-73.18c-74.44-101.3-125.03-221.26-144.2-351.54L358.29,1139.79 L358.29,1139.79z M2007.37,1139.78c-19.26,130.43-70.21,250.45-144.85,351.87l72.54,73.07 c92.25-120.95,154.5-266.4,175.18-424.93h-102.87V1139.78z M770.32,1657.38l-72.54,73.07 c120.04,92.98,264.45,155.63,421.81,176.48V1803.2C990.15,1783.77,870.91,1732.56,770.32,1657.38z M1698.38,1656.74 c-100.65,75.11-219.68,126.62-349.17,145.92v103.41c157.39-20.7,301.72-83.32,421.81-176.15l-72.32-73.18H1698.38 L1698.38,1656.74z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.5,200.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1001.33,
    cy: 1000,
    rx: 958.67,
    ry: 960
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepublicWhite);
export default __webpack_public_path__ + "static/media/republicWhite.10c1dc6605c913f91216823cef613144.svg";
export { ForwardRef as ReactComponent };